import React, { createContext, useContext, useEffect, useState } from 'react';
import { notificationService } from '../services/NotificationService';
import { useAuth } from './AuthContext';

interface NotificationContextType {
  notificationsEnabled: boolean;
  requestPermission: () => Promise<boolean>;
}

const NotificationContext = createContext<NotificationContextType>({
  notificationsEnabled: false,
  requestPermission: async () => false
});

export function useNotifications() {
  return useContext(NotificationContext);
}

export function NotificationProvider({ children }: { children: React.ReactNode }) {
  const [notificationsEnabled, setNotificationsEnabled] = useState(false);
  const { user } = useAuth();

  useEffect(() => {
    const initializeNotifications = async () => {
      const enabled = await notificationService.initialize();
      setNotificationsEnabled(enabled);

      if (enabled && user) {
        notificationService.startListening();
      }
    };

    initializeNotifications();

    return () => {
      notificationService.stopListening();
    };
  }, [user]);

  const requestPermission = async () => {
    const enabled = await notificationService.initialize();
    setNotificationsEnabled(enabled);
    return enabled;
  };

  return (
    <NotificationContext.Provider value={{ notificationsEnabled, requestPermission }}>
      {children}
    </NotificationContext.Provider>
  );
}